/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment  } from 'react'
import { Table, Divider, Popconfirm } from 'antd'
import styles from './index.less'
import moment from 'moment'
import {
  GENDER_ENUM,
  ORDER_STATUS_MAP,
  ORDER_EXECUTION_STATUS_MAP,
  ORDER_STATUS_TO_CONFIRM,
  ORDER_STATUS_TO_PAY,
  ORDER_STATUS_PART_PAY,
  ORDER_STATUS_REFUNDING,
  ORDER_STATUS_REFUNDED,
  ORDER_STATUS_CANCEL, ORDER_STATUS_PAID,
  ORDER_STATUS_SUCCESS
} from '@/utils/consts';

const OrderList = ({ data, pagination,onChange, onEdit, deleteOrder,cancelOrder  }) => {
  const columns = [
    // {
    //   dataIndex: 'code',
    //   title: '订单编码',
    //   width: 100,
    // },
    {
      dataIndex: 'orderDate',
      width: 140,
      title: '下单时间',
      render(text) {
        return moment(text).format('YYYY-MM-DD')
      }
    },
    {
      dataIndex: 'status',
      title: '订单状态',
      width: 100,
      align: 'center',
      render: status => <span className={status}>{ORDER_STATUS_MAP[status]}</span>
    },
    {
      dataIndex: 'executionStatus',
      title: '执行状态',
      width: 100,
      align: 'center',
      render: status => <span className={`executionStatus${status}`}>{ORDER_EXECUTION_STATUS_MAP[status]}</span>
    },
    {
      dataIndex: 'amount',
      title: '订单金额',
      width: 100,
      align: 'right',
      render: amount => amount > 0 ? amount + '元' : undefined,
    },
    // {
    //   dataIndex: 'discount',
    //   title: '整单折扣',
    //   width: 90,
    //   align: 'right',
    //   render(discount) {
    //     return (discount <= 1 ? discount * 100 : discount) + '%'
    //   },
    // },
    {
      dataIndex: 'actualAmount',
      title: '实收金额',
      width: 100,
      align: 'right',
      render: actualAmount => actualAmount > 0 ? actualAmount + '元' : undefined,
    },
    {
      dataIndex: 'riseAmount',
      title: '升单金额',
      width: 100,
      align: 'right',
      render: amount => amount > 0 ? amount + '元' : undefined,
    },
    {
      key: 'assistantDoctorName',
      title: '在线医助',
      width: 100,
      align: 'center',
      render: (_, record) => (record.assistantDoctor || {}).nickname
    },
    {
      key: 'consultantDoctorName',
      title: '心理顾问',
      width: 100,
      align: 'center',
      render: (_, record) => (record.consultantDoctor || {}).nickname
    },
    {
      key: 'personalDoctorName',
      title: '私人管家',
      width: 100,
      align: 'center',
      render: (_, record) => (record.personalDoctor || {}).nickname
    },
    {
      key: 'assistantCreatedBy',
      title: '成交协助人',
      width: 100,
      align: 'center',
      render: (_, record) => (record.assistantCreatedByUser || {}).nickname
    },
    {
      dataIndex: 'operation',
      title: '操作',
      width: 120,
      align: 'center',
      render(text, record) {
        const status = record.status;

        // 待确认
        if (status === ORDER_STATUS_TO_CONFIRM) {
          return (
            <Fragment>
              <a href="javascript:void(0);" onClick={() => onEdit(record)}>编辑</a>
              <Divider type="vertical" />
              <Popconfirm title="确认删除此订单吗？" placement="topLeft" onConfirm={() => deleteOrder(record)}>
                <a href="javascript:void(0);">删除</a>
              </Popconfirm>
            </Fragment>
          );
        }

        // 待支付
        if (status === ORDER_STATUS_TO_PAY) {
          return (
            <Fragment>
              {!record.isReservation && <Popconfirm title='确认取消此订单吗？' placement="topLeft" onConfirm={() => cancelOrder(record.id, record.customerId)}>
                <a href="javascript:void(0);">取消</a>
              </Popconfirm>}
            </Fragment>
          );
        }

        // 已取消
        if (status === ORDER_STATUS_CANCEL) {
          return (
            <Fragment>
              <Popconfirm title="确认删除此订单吗？" placement="topLeft" onConfirm={() => deleteOrder(record)}>
                <a href="javascript:void(0);">删除</a>
              </Popconfirm>
            </Fragment>
          );
        }

        // 已完成
        if (status === ORDER_STATUS_SUCCESS) {
          return (
            <Fragment>
              
            </Fragment>
          );
        }

        // 部分已支付
        if (status === ORDER_STATUS_PART_PAY) {
          // return (
          //   <Fragment>
          //     {!record.isReservation &&
          //     <Fragment>
          //       <a href="javascript:void(0);">申请退款</a>
          //     </Fragment>
          //     }
          //   </Fragment>
          // );
        }

        // 已支付
        if (status === ORDER_STATUS_PAID) {
          // return (
          //   <Fragment>
          //     {!record.isReservation &&
          //     <Fragment>
          //       <a href="javascript:void(0);">申请退款</a>
          //     </Fragment>
          //     }
          //   </Fragment>
          // );
        }

        // 退款中
        if (status === ORDER_STATUS_REFUNDING) {

        }

        // 已退款
        if (status === ORDER_STATUS_REFUNDED) {

        }
      }
    }
  ]
  console.log(pagination)
  return (
    <div className={styles.follow}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          ...pagination,
          onChange
        }}
        scroll={{x:1060}}
        expandIcon={({expanded, onExpand}) => <span className='icon-wrapper'><span className={expanded ? 'icon-expanded' : 'icon-collapse' } onClick={onExpand} /></span>}
        expandedRowRender={expandedRowRender}
        size="small"
        rowKey="id"
      />
    </div>
  )
}

export default OrderList

function expandedRowRender(record) {
  const columns = [
    // {
    //   title: '序号',
    //   key: 'index.less',
    //   render: (_, record, index) => index + 1,
    //   width: 70,
    //   align: 'center',
    // },
    // {
    //   title: '订单条目编码',
    //   dataIndex: 'orderItemCode',
    // },
    {
      title: '商品类别',
      key: 'productCategoryName',
      width: 160,
      ellipsis: true,
      render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    },
    {
      title: '商品名称',
      dataIndex: 'name',
    },
    {
      title: '商品原价',
      dataIndex: 'price',
      width: 120,
      align: 'right',
      render: (price) => price > 0 ? price + '元' : undefined
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      width: 80,
      align: 'right',
    },
    {
      title: '折扣',
      dataIndex: 'discount',
      width: 100,
      align: 'right',
      render: discount => discount <= 1 ? Number(discount * 100).toFixed(2) + '%' : undefined
    },
    {
      title: '单项立减',
      dataIndex: 'couponPrice',
      width: 100,
      align: 'right',
      render: (amount) => amount > 0 ? amount + '元' : undefined
    },
    {
      title: '实收金额',
      dataIndex: 'actualAmount',
      width: 120,
      align: 'right',
      render: (amount) => amount > 0 ? amount + '元' : undefined
    }
  ]

  return <Table size='small' columns={columns} pagination={false} dataSource={record.orderItemVos || []} bordered={false}/>
};
